var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconStream = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00039 5.99902C7.10496 5.99902 8.00039 5.10359 8.00039 3.99902C8.00039 2.89445 7.10496 1.99902 6.00039 1.99902C4.89582 1.99902 4.00039 2.89445 4.00039 3.99902C4.00039 5.10359 4.89582 5.99902 6.00039 5.99902Z",
    fill: "#09090A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.744 2.31836C3.41924 2.79777 3.22953 3.37614 3.22953 3.99881C3.22953 4.62808 3.42328 5.2121 3.75437 5.69447L2.95568 6.29763C2.49816 5.64726 2.22953 4.85441 2.22953 3.99881C2.22953 3.14979 2.49405 2.36256 2.94516 1.71502L3.744 2.31836Z",
    fill: "#09090A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39819 1.30191C1.83413 2.0537 1.5 2.98685 1.5 3.9995C1.5 5.0131 1.83476 5.94705 2.39977 6.6992L1.60023 7.29981C0.909705 6.38058 0.5 5.23727 0.5 3.9995C0.5 2.76174 0.909698 1.61845 1.60021 0.699219L2.39819 1.30191Z",
    fill: "#09090A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25676 2.31836C8.58153 2.79777 8.77123 3.37614 8.77123 3.99881C8.77123 4.62808 8.57749 5.2121 8.24639 5.69447L9.04508 6.29763C9.5026 5.64726 9.77123 4.85441 9.77123 3.99881C9.77123 3.14979 9.50672 2.36256 9.0556 1.71502L8.25676 2.31836Z",
    fill: "#09090A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60257 1.30191C10.1666 2.0537 10.5008 2.98684 10.5008 3.9995C10.5008 5.0131 10.166 5.94705 9.60099 6.6992L10.4005 7.29981C11.0911 6.38058 11.5008 5.23727 11.5008 3.9995C11.5008 2.76174 11.0911 1.61845 10.4005 0.699219L9.60257 1.30191Z",
    fill: "#09090A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconStream);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-stream.69e0c15f83be148aa66009e7aec6541c.svg";